/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchAccounts.defs.js'
export * as $defs from './searchAccounts.defs.js'
